
<template>
  <div class="working-process-area ptb-100">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <div class="working-process-content">
            <span class="sub-title">Nosso Processo de Trabalho</span>
            <h2>Dedicados a transformar suas ideias em soluções digitais</h2>
            <ul class="working-process-list">
              <li data-aos="fade-up" data-aos-duration="1200">
                <div class="number">
                  1
                </div>
                <h3>Análise & Planejamento</h3>
                <p>Entendemos profundamente suas necessidades de negócio, analisamos requisitos técnicos e definimos a melhor arquitetura para seu projeto.</p>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
                <div class="number">
                  2
                </div>
                <h3>Desenvolvimento & Testes</h3>
                <p>Criamos sua solução utilizando metodologias ágeis, com entregas incrementais e testes rigorosos para garantir qualidade e performance.</p>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
                <div class="number">
                  3
                </div>
                <h3>Entrega & Suporte</h3>
                <p>Realizamos o deploy em ambiente de produção e oferecemos suporte contínuo para manter sua solução sempre atualizada e funcionando perfeitamente.</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="working-process-image bg1">
            <img src="../../assets/images/working-process.jpg" alt="Processo de desenvolvimento Fontes Business">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OurWorkingProcess'
}
</script>